import { getAuth } from "firebase/auth";
import { useEffect, useState } from "react";
import GetSchool from "../../../../Controllers/Common/GetSchool";
import GetUser from "../../../../Controllers/Users/GetUser";

export default function SchoolsListingViewModel() {
  const [SchoolID, setSchoolID] = useState("");
  const [IsLoading, setIsLoading] = useState(false);
  const [AuthUser, setAuthUser] = useState();
  const [SchoolObject, setSchoolObject] = useState([]);

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("schoolId"));
    setSchoolID(items);
  }, []);

  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async (user) => {
        const UserData = await GetUser(user?.uid);
        setAuthUser(UserData);
      });
    }
    fetchData();
  }, []);

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      let SchoolsData = await GetSchool(SchoolID);

      // SchoolName Start
      const ArrayOfSchoolNameWords = SchoolsData?.SchoolName?.split(" ");
      for (var i = 0; i < ArrayOfSchoolNameWords?.length; i++) {
        ArrayOfSchoolNameWords[i] =
          ArrayOfSchoolNameWords[i]?.charAt(0)?.toUpperCase() +
          ArrayOfSchoolNameWords[i]?.slice(1);
      }
      const StringOfSchoolNameWords = ArrayOfSchoolNameWords?.join(" ");
      SchoolsData["SchoolName"] = StringOfSchoolNameWords;
      // SchoolName End

      // HOD Start
      const ArrayOfHeadOfSchoolWords = SchoolsData?.HeadOfSchool?.split(" ");
      for (var j = 0; j < ArrayOfHeadOfSchoolWords?.length; j++) {
        ArrayOfHeadOfSchoolWords[j] =
          ArrayOfHeadOfSchoolWords[j]?.charAt(0)?.toUpperCase() +
          ArrayOfHeadOfSchoolWords[j]?.slice(1);
      }
      const StringOfHeadOfSchoolWords = ArrayOfHeadOfSchoolWords?.join(" ");
      SchoolsData["HeadOfSchool"] = StringOfHeadOfSchoolWords;
      // HOD End

      setSchoolObject(SchoolsData);
      setIsLoading(false);
    }
    fetchData();
  }, [SchoolID]);

  return { SchoolObject, AuthUser, IsLoading };
}
